module.exports = __webpack_public_path__ + "media/section6_h_v3.d2b166c7.mp3";